<section class="FirstScroll_Section">
    <p class="heading">A repository of key messages from notable personalities and dignitaries.</p>
    <div class="container nopad">
        <div class="row">
<div class="col-sm-5 py-2 py-sm-0" style="float: left;">
    <a href="https://www.youtube.com/embed/Tj_y2N4NkSE" data-toggle="modal" data-target="#myModal1">
        <img src="http://img.youtube.com/vi/Tj_y2N4NkSE/hqdefault.jpg" class="img-fluid">
        <a class="pin pin1"><span class="fa fa-play"></span></a>
    </a>
</div>

<div class="col-sm-7 py-3 py-sm-0" style="float: right;">
    <figure class="quote">
        <h1 class="SectionHeading">Message from the Chairman</h1>
        <blockquote class="quote__body">The transformation of Indian education dates back to it being the pioneer in the 800 BCs where the undivided India had global institutions, whereas the deterioration began with the ages of modernization and industrialization.</blockquote>
        <figcaption class="quote__credits">Prof. Anil D. Sahasrabudhe</figcaption>
        <figcaption class="quote__designation">Chairman</figcaption>
    </figure>
</div>

<!-- Modal -->
<div class="modal fade" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">      
        <div class="modal-body">
         <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>        
          <!-- 16:9 aspect ratio -->
          <div class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/Tj_y2N4NkSE" id="video" allow="autoplay"></iframe>
          </div> 
        </div>
      </div>
    </div>
  </div>     

</div>
</div>
</section>
